<template>
  <div id="edit_hvut_category" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
             <div class="page-name" >
                    <span class="page-title" id="hvutHeader" v-if="$route.params.id > 0">Update FHUT Category</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackRequestList" >
                        <i class="fp-back"> </i> Back
                    </button>
              </div>
              <div class="container-fluid">
                <div class="admin-page-content hvut-category-update">
                  <section class="internal-container border-top-table-fl">
                    <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="hvutCategoryUpdateForm">
                      <div class="form-row row-cols-md-4 row-cols-1">
                        <div class="col form-group">
                            <label class="control-label "  for="code">Code:</label>
                            <input type="text" class="form-control" disabled v-model="code" id="code" placeholder="Enter Code" name="code">

                        </div>
                        <div class="col form-group">
                            <label class="control-label "  for="weight">Weight:</label>
                            <input type="text" class="form-control"  disabled v-model="weight" id="weight" placeholder="Enter Weight" name="weight">

                        </div>
                        <div class="col form-group">
                            <label class="control-label require" for="amount">Amount:</label>
                            <input type="text" class="form-control"
                             v-model="amount"
                             @blur="leaveFocus"
                            @focus="enterVal"
                            @input="validateInput"
                             id="amount" placeholder="Enter Amount" name="amount">
                            <div class="field-error">{{amount_err_msg}}</div>
                        </div>
                      </div>
                      <div class="btn-groups">
                            <button type="submit" id="EditHvutCategoryBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="EditHvutCategory" >
                                <i class="fp-reload"> </i>  Update
                            </button>
                            <button  type="submit" id="cancelBtn" class="btn btn-tertiary" v-on:click.prevent="BackRequestList" >
                                <i class="fp-close"> </i>  Cancel
                            </button>

                      </div>
                    </form>
                  </section>
                </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
        </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';

var self;
export default {
  name:"HVUTCategoriesUpdate",

  components: {

      
  },
  mixins:[commonMixins],
  data: () => ({
     loading:false,
     code:"",
     weight:"",
     amount:"",
     amount_err_msg:"",
     cantAccessPage:"",
     permissions: [],
   }),
   watch:{
      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_hvut_schedule') {
                      self.cantAccessPage = true;
                  }
              }
          }
      }
  },
  mounted() {
     var self = this;
     self.getPermissions();
     setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadHVUTCategoryData();

            }
      }, 100);
  },
  methods: {
    validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      // if(evt.target.value > 999999.99) {
      //   self.amount_err_msg = "Amount value exceed";
      // } else {
      //   self.amount_err_msg = "";
      // }
    },
    enterVal:function(evt) {
      evt = (evt) ? evt : window.event;
      console.log("ENTER  ==", evt.target.value);
      this.amount = evt.target.value;
      this.amount = evt.target.value.replace(/\,/g,"");
    },
    leaveFocus:function(evt) {
      evt = (evt) ? evt : window.event;
      console.log("focus ==", evt.target.value);
      this.amount =  this.amountFormat(evt.target.value);
    },
    amountFormat(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
        });

        return formatter.format(amount);
    },
    BackRequestList() {
      var self = this;
      self.$router.push('/fhut-categories/list');
    },
    loadHVUTCategoryData() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/hvut-category/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.weight = data.content.weight;
                    self.amount = self.amountFormat(data.content.amount);
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'hvut-category-by-id')
            }
        });
    },
    EditHvutCategory(){
      var error = false;

      var self = this;

      if (!self.amount || self.amount == ''||self.amount == null) {
          self.amount_err_msg = 'Amount Required';
          error = true;
      }
      if (!error) {
          self.loading = true;
          var path = window.location.pathname;
          var segments = path.split("/");
          $("#EditHvutCategoryBtn").val("Updating ...");
          $("#cancelBtn").prop("disabled",true);
          $.ajax({
                url: process.env.ROOT_API + "/hvut-category/update",
                type: "POST",
                data: {code: self.code, weight: self.weight, amount: self.amount.replace(/\,/g,""), id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    $("#EditHvutCategoryBtn").val("Update");
                    $("#cancelBtn").prop("disabled",false);
                    if (data.status == "success") {

                        self.$router.push("/fhut-categories/list");

                    }else{
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }




                },
                error: function (jqXHR, exception) {
                  self.loading = false;

                      $("#EditHvutCategoryBtn").val("Update");
                      $("#cancelBtn").prop("disabled",false);

                  self.generateStatusCodeMessage(jqXHR,true,'hvut-category-update')


               }
          });
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/hvut/UpdateHVUTCategories.vue